import React from 'react';
import './ChoicePicker.css';

export type MultiChoiceOption<T extends string> = {
  value: T;
  label: string;
};

export interface MultiChoicePickerProps<T extends string> {
  values: ReadonlyArray<T>;
  options: ReadonlyArray<MultiChoiceOption<T>>;
  onChange: (next: T[]) => void;
  className?: string;
}

const MultiChoicePicker = <T extends string>({
  values,
  options,
  onChange,
  className,
}: MultiChoicePickerProps<T>) => {
  const toggle = (v: T) => {
    if (values.includes(v)) {
      onChange(values.filter((x) => x !== v));
    } else {
      onChange([...values, v]);
    }
  };

  return (
    <div className={`ff-choice-picker ff-choice-picker--multi ${className ?? ''}`.trim()}>
      {options.map((opt) => {
        const selected = values.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            className={`ff-choice-picker__btn ${selected ? 'ff-choice-picker__btn--selected' : ''}`}
            onClick={() => toggle(opt.value)}
          >
            <span className="ff-choice-picker__dot" aria-hidden />
            <span className="ff-choice-picker__label">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default MultiChoicePicker;
